export const disableUserSelect = () => {
    document.body.style.userSelect = "none";
};
export const enableUserSelect = () => {
    document.body.style.userSelect = "";
};
